import * as requests from './requests'
import constants from './constants'
import urls from './urls'

// Biblioteca Prediseño SVG
export async function getBibliotecasPredSvg() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_BIBPREDSVG)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEnums() {
  return requests.get(constants.API_URL_PERSONALIZACION, urls.GET_ENUMS).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function deleteBibliotecaPredSvg(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_BIBPREDSVG_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getBibliotecaPredSvgById(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBPREDSVG_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibPreByBibPlantillaId(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBPREDSVG_BY_BIBPLANTILLA_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibPredByProductoId(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBPREDSVG_BY_PRODUCTO_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibPredProductosByPlantillaId(payload) {
  return requests
    .get(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBPREDSVG_PRODUCTOS_BY_PLANTILLA_ID}/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertBibliotecaPredSvg(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.INSERT_BIBPREDSVG, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaPredSvg(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.UPDATE_BIBPREDSVG, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecasPredSvgProducto(payload) {
  return requests
    .put(
      constants.API_URL_PERSONALIZACION,
      `${urls.UPDATE_BIBSPREDSVG_PRODUCTO}/${payload.idProducto}`,
      payload.bibliotecasPredSvgProducto,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasPredSvgFiltered(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_BIBPREDSVG_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasPredSvgFilteredWithFiles(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_BIBPLANTILLA_WITH_FILES_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Tipos Svg
export async function getTiposSvg() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_TIPOS_SVG)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertTipoSvg(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_TIPO_SVG, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Subtipos Svg
export async function getSubtiposSvgByBibliotecaPlantillaId(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_SUBTIPOS_SVG_BY_PLANTILLA_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertSubtipoSvg(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_SUBTIPO_SVG, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Fonts
export async function getFonts({ tipo, eliminado }) {
  let url = urls.GET_FONTS
  if (tipo != null) url = `${url}?tipo=${tipo}`
  if (eliminado != null) url = `${url}&eliminado=${eliminado}`

  return requests.get(constants.API_URL_PERSONALIZACION, url).then(async response => {
    return { ok: response.ok, data: await response.json() }
  })
}

export async function getFontsFiltered(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_FONTS_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getFontById(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_FONT_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFontById(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_FONT_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function generateFonts(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GENERATE_FONTS, payload)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function insertFont(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.POST_FONT_INSERT, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFont(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.PUT_FONT_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateOrderFont(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.PUT_FONT_ORDER_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Bibliotecas de Plantillas
export async function getBibliotecasPlantillaFiltered(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_BIBPLANTILLA_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasPlantillaFilteredWithFiles(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_BIBPLANTILLA_WITH_FILES_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaPlantilla(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_BIBPLANTILLA_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function insertBibliotecaPlantilla(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.INSERT_BIBPLANTILLA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaPlantilla(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.UPDATE_BIBPLANTILLA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecasPlantillaProducto(payload) {
  return requests
    .put(
      constants.API_URL_PERSONALIZACION,
      `${urls.UPDATE_BIBSPLANTILLA_PRODUCTO}/${payload.idProducto}`,
      payload.bibliotecasPlantillaProducto,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecaPlantillaById(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBPLANTILLA_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibPlantillasByProductoId(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBPLANTILLA_BY_PRODUCTO_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Combos SVG
export async function getCombosSvgFiltered(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_COMBOSVG_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCombosSvgFilteredWithFiles(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_COMBOSVG_WITH_FILES_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteComboSvg(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_COMBOSVG_BY_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function insertComboSvg(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_COMBOSVG, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateComboSvg(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_COMBOSVG, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getComboSvgById(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_COMBOSVG_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCombosSvgByProductoId(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_COMBOS_SVG_BY_PRODUCTO_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCombosSvgByPlantillaId(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_COMBOS_SVG_BY_PLANTILLA_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getComboSvgProductoById(payload) {
  return requests
    .get(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBO_ID}/${payload.idProducto}/${payload.idComboSvg}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateCombosSvgProducto(payload) {
  return requests
    .put(
      constants.API_URL_PERSONALIZACION,
      `${urls.UPDATE_COMBOS_SVG_PRODUCTO}/${payload.idProducto}`,
      payload.combosSvgProducto,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateComboSvgProducto(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, `${urls.UPDATE_COMBO_SVG_PRODUCTO}`, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// DISENOS CLIENTE SVG

export async function getDisenoClienteSvgById(payload) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_DISENO_SVG_BY_ID}/${payload}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getDatosImpresionDisenoClienteSvg(payload, ventaId = null) {
  const query = ventaId != null ? `?ventaId=${ventaId}` : '';  
  return requests  
    .get(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_DATOS_IMPRESION_DISENO_SVG_BY_ID}/${payload}${query}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function generarDisenoFinalSvg(id, body) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, `${urls.GENERAR_DISENO_FINAL_SVG}/${id}`, body)
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function guardarDisenoFinalPegatina(id, body) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, `${urls.GUARDAR_DISENO_PEGATINA}/${id}`, body)
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function addEtiquetaToDiseno(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.ADD_ETIQUETA_DISENO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function eliminarImagenFinalDiseno(payload) {
  return requests
    .remove(
      constants.API_URL_PERSONALIZACION,
      `${urls.ELIMINAR_IMAGEN_DISENO_FINAL}/${payload.disenoClienteGuid}/${payload.disenoSvgId}/${payload.filename}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.blob() }
    })
}

export async function insertIlustracion(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.INSERT_ILUSTRACION_IMAGEN, payload)
    .then(async response => {
      // El endpoint responde 400 con el motivo en texto plano, así que no se puede parsear siempre como json.
      if (!response.ok) return { ok: false, message: await response.text() }
      return { ok: true, data: await response.json() }
    })
}

export async function eliminarIlustracion(disenoClienteGuid, ilustracionId) {
  return requests
    .remove(
      constants.API_URL_PERSONALIZACION,
      `${urls.DELETE_ILUSTRACION_IMAGEN}/${disenoClienteGuid}/${ilustracionId}`,
    )
    .then(async response => {
      return { ok: response.ok }
    })
}

export async function getSpotifyCodeToken() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_SPOTIFY_TOKEN)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function spotifyCodeSearch(token, term) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.SPOTIFY_SEARCH}?token=${token}&search=${term}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getSpotifyCodeSvg(uri) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_SPOTIFY_CODE_SVG}?uri=${uri}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getSpotifyCodePng(uri, isTransparent, colorFondo) {
  let url = `${urls.GET_SPOTIFY_CODE_PNG}?uri=${uri}&isTransparent=${isTransparent}`
  if (colorFondo) url = `${url}&colorFondo=${colorFondo}`
  return requests.get(constants.API_URL_PERSONALIZACION, url).then(async response => {
    return { ok: response.ok, data: await response.blob() }
  })
}

export async function guardarDisenoSvgAmazon(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.GUARDAR_DISENO_AMAZON, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// BIBLIOTECA DE PREGUNTAS

export async function getBibliotecasPreguntas() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_BIBLIOTECAS_PREGUNTAS)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasPreguntasFiltered(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_BIBLIOTECAS_PREGUNTAS_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaPregunta(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_BIBLIOTECA_PREGUNTA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: null }
    })
}

export async function insertBibliotecaPregunta(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_BIBLIOTECA_PREGUNTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaPregunta(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_BIBLIOTECA_PREGUNTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaPreguntaSetEsPijama(payload) {
  return requests
    .patch(
      constants.API_URL_PERSONALIZACION,
      `${urls.SET_ESPIJAMA_BIBLIOTECA_PREGUNTA}/${payload.id}?activado=${payload.activado}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.text() }
    })
}

export async function updateBibliotecaPreguntaSetRepetirByQuantity(payload) {
  return requests
    .patch(
      constants.API_URL_PERSONALIZACION,
      `${urls.SET_REPETIR_BY_QUANTITY_BIBLIOTECA_PREGUNTA}/${payload.id}?activado=${payload.activado}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.text() }
    })
}

export async function duplicateBibliotecaPregunta(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.DUPLICATE_BIBLIOTECA_PREGUNTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertPreguntaBiblioteca(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_PREGUNTA_BIBLIOTECA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function insertOpcionPregunta(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_OPCION_PREGUNTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateOpcionPregunta(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_OPCION_PREGUNTA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecaPreguntaById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBLIOTECA_PREGUNTA_BY_ID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecaPreguntaProductoById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBLIOTECA_PREGUNTA_BY_PRODUCTO_ID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecasPreguntasProducto(payload) {
  return requests
    .put(
      constants.API_URL_PERSONALIZACION,
      `${urls.UPDATE_BIBPREGUNTAS_PRODUCTO}/${payload.idProducto}`,
      payload.bibliotecasPreguntasProducto,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// BIBLIOTECA DE FAMILIAS

export async function getBibliotecasFamilia() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_BIBFAMILIA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasFamiliaById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBFAMILIA_BY_ID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getPegatinasFamiliaConImagenByBiblitecaId(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_PEGATINAS_FAMILIA_IMAGEN_BY_BIBLITECAID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updatePegatinasFamiliaOrden(payload) {
  return requests
    .patch(constants.API_URL_PERSONALIZACION, urls.UPDATE_PEGATINAS_ORDEN, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasFamiliaFiltered(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_BIBFAMILIA_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaFamilia(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_BIBFAMILIA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaFamilia(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_BIBFAMILIA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertBibliotecaFamilia(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_BIBFAMILIA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getEtiquetasFamilia() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.ETIQUETA_FAMILIA_CONTROLLER)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateEtiquetaFamilia(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.ETIQUETA_FAMILIA_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertEtiquetaFamilia(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.ETIQUETA_FAMILIA_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteEtiquetaFamilia(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.ETIQUETA_FAMILIA_CONTROLLER}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updatePegatinaFamilia(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.UPDATE_PEGATINA_FAMILIA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertPegatinaFamilia(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.INSERT_PEGATINA_FAMILIA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deletePegatinaFamilia(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_PEGATINA_FAMILIA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteMasivoPegatinaFamiliaBybibliotecaFamiliaId(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_PEGATINA_FAMILIA_MASIVO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertMasivoPegatinaFamilia(form) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.INSERT_PEGATINA_FAMILIA_MASIVO, form)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecasFamiliaProducto(payload) {
  return requests
    .put(
      constants.API_URL_PERSONALIZACION,
      `${urls.UPDATE_BIBFAMILIA_PRODUCTO}/${payload.idProducto}`,
      payload.bibliotecasFamiliaProducto,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasFamiliaProductoById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBLIOTECA_FAMILIA_BY_PRODUCTO_ID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// BIBLIOTECA DE FONDOS PARA FAMILIAS

export async function getBibliotecasFondoFamilia() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_BIBFONDOFAMILIA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasFondoFamiliaById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBFONDOFAMILIA_BY_ID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasFondoFamiliaFiltered(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_BIBFONDOFAMILIA_FILTERED, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaFondoFamilia(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_BIBFONDOFAMILIA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaFondoFamilia(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_BIBFONDOFAMILIA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaFondoFamiliaAreas(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_BIBFONDOFAMILIA_AREAS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertBibliotecaFondoFamilia(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_BIBFONDOFAMILIA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteFondoFamiliaFile(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_FONDO_FILE}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateFondoFamiliaFile(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.UPDATE_FONDO_FILE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertFondoFamiliaFile(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.INSERT_FONDO_FILE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertMasivoFondoFamilia(form) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.INSERT_FONDO_FAMILIA_MASIVO, form)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecaFamiliaProductoById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBLIOTECA_FAMILIA_BY_PRODUCTO_ID}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// CHOCOMENSAJE
export async function getChocomensajeByProductoId(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_CHOCOMENSAJE_PRODUCTO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertChocomensajeProductoId(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_CHOCOMENSAJE_PRODUCTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function updateChocomensajeProductoId(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_CHOCOMENSAJE_PRODUCTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function deleteChocomensajeByProductoId(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_CHOCOMENSAJE_PRODUCTO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// IMAGEN CLIENTE
export async function getImagenClienteByProductoId(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_IMAGEN_CLIENTE_PRODUCTO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertImagenClienteProductoId(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_IMAGEN_CLIENTE_PRODUCTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function updateImagenClienteProductoId(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_IMAGEN_CLIENTE_PRODUCTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function deleteImagenClienteByProductoId(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_IMAGEN_CLIENTE_PRODUCTO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// aUDIO
export async function getAudioByProductoId(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_AUDIO_PRODUCTO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertAudioProducto(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_AUDIO_PRODUCTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function updateAudioProducto(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_AUDIO_PRODUCTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function deleteAudioProductoById(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_AUDIO_PRODUCTO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// LegoProps
export async function getLegoPropsByProductoId(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.LEGO_PROPS_CONTROLLER}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertLegoPropsProductoId(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.LEGO_PROPS_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function updateLegoPropsProductoId(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.LEGO_PROPS_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function deleteLegoPropsByProductoId(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.LEGO_PROPS_CONTROLLER}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Colores Lego
export async function getColoresLego() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.COLOR_LEGO_CONTROLLER}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function getColorLegoById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.COLOR_LEGO_CONTROLLER}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertColorLego(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.COLOR_LEGO_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function updateColorLego(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.COLOR_LEGO_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateRangeColoresLego(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.COLOR_LEGO_RANGE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function deleteColorLego(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.COLOR_LEGO_CONTROLLER}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
// Personalizacion Cliente

export async function getPersonalizacionByProducto(productoId) {
  return requests
    .get(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_PERSONALIZACION_PRODUCTO}?idProducto=${productoId}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

// Opciones de spotify

export async function getOpcionesSpotifyByProductoId(productoId) {
  return requests
    .get(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_OPCIONES_SPOTIFY_BY_PRODUCTID}/${productoId}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function insertOpcionesSpotify(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.INSERT_OPCIONES_SPOTIFY, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateOpcionesSpotify(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.UPDATE_OPCIONES_SPOTIFY, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteOpcionesSpotify(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_OPCIONES_SPOTIFY}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Personalizacion Color Lego
export async function getDisenosColorLego() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.PERSONALIZACION_LEGO_CONTROLLER}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function getDisenoColorLegoById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.PERSONALIZACION_LEGO_CONTROLLER}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertDisenoColorLego(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.PERSONALIZACION_LEGO_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function updateDisenoColorLego(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.PERSONALIZACION_LEGO_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateRangeDisenosColorLego(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.PERSONALIZACION_LEGO_RANGE_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertRangeDisenosColorLego(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.PERSONALIZACION_LEGO_RANGE_CONTROLLER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteRangeDisenoColorLego(id) {
  return requests
    .remove(
      constants.API_URL_PERSONALIZACION,
      `${urls.PERSONALIZACION_LEGO_RANGE_CONTROLLER}/${id}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteDisenoColorLego(id) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.PERSONALIZACION_LEGO_CONTROLLER}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getStickers(deleted) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.STICKERS}?&deleted=${deleted ?? true}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getSticker(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.STICKERS}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getStickerByCategoria(categoriaId) {
  return requests
    .get(
      constants.API_URL_PERSONALIZACION,
      `${urls.STICKERS}/stickersByCategoria?categoriaId=${categoriaId}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertStickers(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.STICKERS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateStickers(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.STICKERS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteStickers(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.STICKERS}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function getCategoriasStickers(deleted) {
  return requests
    .get(
      constants.API_URL_PERSONALIZACION,
      `${urls.CATEGORIAS_STICKERS}?&deleted=${deleted ?? true}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getCategoriaSticker(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.CATEGORIAS_STICKERS}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertCategoriasStickers(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.CATEGORIAS_STICKERS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateCategoriasStickers(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.CATEGORIAS_STICKERS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteCategoriasStickers(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.CATEGORIAS_STICKERS}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Biblioteca Avatares
export async function getBibliotecasAvatares() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function getBibliotecasAvataresById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertBibliotecaAvatares(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaAvatares(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaAvatares(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function duplicarBibliotecaAvatares(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.POST_BIBAVATARES_DUPLICAR, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

// Activar / desactivar objetos de la galería
export async function activarObjetosAvataresGaleria(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.POST_BIBAVATARES_GALERIA_ACTIVAR, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function eliminarObjetosAvataresGaleria(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.POST_BIBAVATARES_GALERIA_ELIMINAR, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function ordenSeccionAvataresGaleria(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.POST_BIBAVATARES_GALERIA_ORDEN, payload)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

// Biblioteca de Avatares -> Modelo
export async function getBibliotecasAvataresModeloById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_MODELO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

// Biblioteca de Avatares -> Secciones
export async function getBibliotecasAvataresSecciones() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_SECCION)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function getBibliotecasAvataresSeccionById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_SECCION}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertBibliotecaAvataresSeccion(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_SECCION, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaAvataresSeccion(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_SECCION, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaAvataresSeccion(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_SECCION}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateBibliotecaAvataresSeccionOrder(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.PUT_BIBAVATARES_SECCION_ORDER_UPDATE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
// Biblioteca de Avatares -> Paletas
export async function getBibliotecasAvataresPaletas(fam) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_PALETA}/${fam}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function getBibliotecasAvataresPaletaById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_PALETA}/paletaid/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertBibliotecaAvataresPaleta(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_PALETA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaAvataresPaleta(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_PALETA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaAvataresPaleta(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_PALETA}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}
export async function duplicarBibliotecaAvataresPaleta(payload) {
  return requests
    .postForm(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_PALETA}/duplicar/`,
      payload,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Biblioteca de Avatares -> Tamaños
export async function getBibliotecasAvataresSizes() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_SIZE)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function getBibliotecasAvataresSizesFam() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_SIZE_FAM)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function getBibliotecasAvataresSizeById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_SIZE}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertBibliotecaAvataresSize(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_SIZE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaAvataresSize(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_SIZE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaAvataresSize(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_SIZE}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}
// Avatares de cliente
export async function getBibliotecaAvataresClienteResume(fecha) {
  return requests
    .get(constants.API_URL_AVATARES, `${urls.GET_BIBAVATARES_CLIENTE_RESUME}?fecha=${fecha}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecaAvataresClienteAdmin(obj) {  
  return requests
    .get(
      constants.API_URL_AVATARES,
      `${urls.GET_BIBAVATARES_CLIENTE_ADMIN}?fecha=${obj.fecha}&tipo=${obj.tipo}&familia=${obj.familia}&nombre=${obj.nombre}&page=${obj.page}`,      
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecaAvataresClienteEmailAdmin(obj) {  
  return requests
    .get(
      constants.API_URL_AVATARES,
      `${urls.GET_BIBAVATARES_CLIENTE_EMAIL_ADMIN}?email=${obj}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Avatares galeria de familia
export async function getBibliotecaAvataresGaleria(data) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_GALERIA}/galeria/`, data)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

// Biblioteca de Avatares -> Objeto
export async function getBibliotecasAvataresObjetoById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_OBJETO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function deleteBibliotecaAvataresObjeto(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_OBJETO}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateBibliotecaAvataresObjeto(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_OBJETO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Biblioteca de Avatares -> Objeto único
export async function getBibliotecasAvataresObjetoUnicoById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_OBJETO_UNICO}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function updateBibliotecaAvataresObjetoUnico(form) {
  return requests
    .postForm(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_OBJETO_UNICO}/cargaminiaturasize/`,
      form,
    )
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

// Biblioteca de Avatares -> Objeto variante
export async function getBibliotecasAvataresObjetoVarianteById(id) {
  return requests
    .get(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_OBJETO_VARIANTE}/getsvgdata/${id}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function updateBibliotecaAvataresObjetoVariante(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_OBJETO_VARIANTE, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaAvataresObjetoVariante(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_OBJETO_VARIANTE}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Biblioteca de avatares -> Caché
export async function updateBibliotecaAvataresCacheCliente(id) {
  return requests
    .putForm(constants.API_URL_AGGREGATOR, `${urls.SET_CACHE_AVATARES}/updatecache/${id}`)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateBibliotecaAvataresCacheAdmin(id) {
  return requests
    .putForm(
      constants.API_URL_AGGREGATOR,
      `${urls.SET_CACHE_AVATARES}/updatecacheadmin/${id}`,
    )
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateBibliotecaAvataresCacheFamilias() {
  return requests
    .putForm(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_GALERIA}/updatecache/familias/`,
    )
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateBibliotecaAvataresCacheProductos() {
  return requests
    .putForm(constants.API_URL_CATALOGO, `${urls.PRODUCTO_GENERICO_ROOT}/updatecache/productos/`)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateBibliotecaAvataresCachePaises() {
  return requests
    .putForm(constants.API_URL_LOGISTICA_PEDIDO, `${urls.GET_PAISES_ROOT}/updatecache/paises/`)
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateBibliotecaAvataresCacheProvincias() {
  return requests
    .putForm(
      constants.API_URL_LOGISTICA_PEDIDO,
      `${urls.GET_PROVINCIAS_ROOT}/updatecache/provincias/`,
    )
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

// Biblioteca de avatares -> Insert masivo
export async function insertMasivoGaleria(form) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_GALERIA}/masivo/`, form)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function confirmMasivoGaleria(form) {
  return requests
    .put(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_GALERIA}/cargamasivo/`,
      form.data,
    )
    .then(async response => {
      return { ok: response.ok, data: response }
    })
}

// Biblioteca de avatares -> Insertar imagen
export async function insertImageGaleria(form) {
  return requests
    .postForm(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_GALERIA}/cargaimagen/`,
      form,
    )
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function insertObjectMiniatura(form) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_OBJETO}/cargamin/`, form)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function deleteObjectMiniatura(payload) {
  return requests
    .remove(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_OBJETO}/deletemin/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function insertObjectImpresion(form) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_OBJETO}/cargaprint/`, form)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function deleteObjectImpresion(payload) {
  return requests
    .remove(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_OBJETO}/deleteprint/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function insertObjectVariante(form) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_OBJETO}/cargavar/`, form)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function updateObjectVarianteSize(form) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_OBJETO}/sizevar/`, form)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function deleteObjectVariante(payload) {
  return requests
    .remove(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_OBJETO}/deletevar/${payload}`,
    )
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

// Biblioteca de Avatares -> Plantillas
export async function getBibliotecasAvataresPlantillas() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_CUSTOM_PLANTILLA)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function getBibliotecasAvataresPlantillaById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_CUSTOM_PLANTILLA}/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertBibliotecaAvataresPlantilla(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_CUSTOM_PLANTILLA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaAvataresPlantilla(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_CUSTOM_PLANTILLA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaAvataresPlantilla(payload) {
  return requests
    .remove(
      constants.API_URL_PERSONALIZACION,
      `${urls.GET_BIBAVATARES_CUSTOM_PLANTILLA}/${payload}`,
    )
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Biblioteca de Avatares -> Objetos de plantilla
export async function getBibliotecasAvataresPlantillaObjetos(idPlantilla) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_CUSTOM_OBJETO}/${idPlantilla}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function getBibliotecasAvataresPlantillaObjetoById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_CUSTOM_OBJETO}/objeto/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

// Avatares -> Stock de piezas
export async function getReportePiezas(payload) {
  return requests
    .post(constants.API_URL_PERSONALIZACION, urls.GET_REPORTE_PIEZAS, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Personalizacion Audio
export async function getDisenoClienteAudioFiles(guid) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_DISENO_CLIENTE_AUDIO_FILES}/${guid}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Biblioteca de Avatares -> Capas
export async function getBibliotecasAvataresLayers(fam) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_LAYER}/${fam}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function getBibliotecasAvataresLayerById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_LAYER}/layerid/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertBibliotecaAvataresLayer(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_LAYER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaAvataresLayer(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_LAYER, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaAvataresLayer(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_LAYER}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Biblioteca de Avatares -> Capas
export async function getBibliotecasAvataresColor(pal) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_COLOR}/${pal}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function insertBibliotecaAvataresColor(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_COLOR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaAvataresColor(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_COLOR, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaAvataresColor(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_COLOR}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

export async function updateBibliotecaAvataresColorOrder(payload) {
  return requests
    .put(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_COLOR}/updateOrder`, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Avatares por producto
export async function getBibliotecasAvataresProdById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_PRODUCTO}/prod/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}

export async function updateBibliotecaAvataresProd(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_PRODUCTO, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

// Biblioteca de Avatares -> Piezas
export async function getBibliotecasAvataresPiezas() {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_PIEZA}`)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}
export async function getBibliotecasAvataresPiezaById(id) {
  return requests
    .get(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_PIEZA}/piezaid/${id}`)
    .then(async response => {
      return { ok: response.ok, data: await processResponseJson(response) }
    })
}
export async function insertBibliotecaAvataresPieza(payload) {
  return requests
    .postForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_PIEZA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function updateBibliotecaAvataresPieza(payload) {
  return requests
    .putForm(constants.API_URL_PERSONALIZACION, urls.GET_BIBAVATARES_PIEZA, payload)
    .then(async response => {
      return { ok: response.ok, data: await response.json() }
    })
}

export async function deleteBibliotecaAvataresPieza(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.GET_BIBAVATARES_PIEZA}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

const processResponseJson = async response => {
  let data = null
  try {
    data = await response.json()
    // eslint-disable-next-line no-unused-vars
  } catch (error) {
    data = null
  }
  return data
}

export async function deletePersonalizacionClienteProducto(payload) {
  return requests
    .remove(constants.API_URL_PERSONALIZACION, `${urls.DELETE_CACHE_PERSONALIZACION_CLIENTE_BY_PRODUCTO_ID}/${payload}`)
    .then(response => {
      return { ok: response.ok, data: response }
    })
}

// Color con el que getFamiliaPreview pinta los nombres de un diseno de familia (hex sin #)
export async function getFontColorFamilia({ disenoClienteGuid, bibliotecaFamiliaId, productoId }) {
  const params = new URLSearchParams({ disenoClienteGuid })
  if (bibliotecaFamiliaId) params.set('bibliotecaFamiliaId', bibliotecaFamiliaId)
  if (productoId) params.set('productoId', productoId)
  const response = await requests.get(
    constants.API_URL_PERSONALIZACION,
    `${urls.GET_FONT_COLOR_FAMILIA}?${params.toString()}`,
  )
  return { ok: response.ok, data: response.ok ? await response.json() : null }
}
